import {AMODELS_EMPTY, useAmodelMutations} from "../../api/amodelsapi";
import {useSexes} from "../../api/sexApi";
import React, {useCallback} from "react";
import {useForm} from "../../utilities/formutilities";
import {Button, Col, Form, FormCheck, FormControl, FormLabel, Row} from "react-bootstrap";
import {Section} from "../grouping/Section";
import {CustomEditor} from "../CustomEditor";
import {FormControlCustom, FormSelectCustom} from "../controls/FormControls";
import {Bounce, toast} from "react-toastify";
import {useEmailMutations} from "../../api/emailapi";
import {pdf, PDFDownloadLink, PDFViewer} from "@react-pdf/renderer";
import {ModelAPdf} from "../formpdf/ModelAPdf";
import {useFileMutations} from "../../api/fileapi";
import {minioBaseUrl} from "../../data/defaultConfig";
import {useCategories} from "../../api/categoriesapi";
import {checkCategoryFromDate} from "../../utilities/dateutilities";
import {useSectors} from "../../api/sectorsapi";
import {useClubs} from "../../api/clubapi";
import {FaCheck} from "react-icons/fa";
import {LabelWithInput} from "../grouping/LabelWithInput";
import {useCountryCodes} from "../../api/countrycodeapi";


export function AmodelForm(props) {
    const {itemEditing, onItemEditingChanged, onOpenChanged} = props;
    const {createAmodel, editAmodel} = useAmodelMutations();
    const {countrycodes} = useCountryCodes();
    const {categories} = useCategories();
    const {createFormEmail} = useEmailMutations();
    const {uploadFile} = useFileMutations();
    const {sexes} = useSexes();
    const {sectors} = useSectors();
    const {clubs} = useClubs();
    const sectorsSorted = sectors ? [...sectors].sort((s1, s2) => ('' + s1.sectorNaam).localeCompare('' + s2.sectorNaam)) : [];
    const clubSorted = clubs ? [...clubs].sort((c1, c2) => ('' + c1.club).localeCompare('' + c2.club)) : [];
    const emptyObject = {
        ...AMODELS_EMPTY,
        opstellingDatum: new Date().toISOString().substring(0, 10),
        optie: "Selecteer reden",
        sex: 'Selecteer geslacht',
        sector: 'Selecteer sector',
        club: 'Selecteer club',
        nationaliteit:'Selecteer nationaliteit',
        land : 'Selecteer land'

    };
    const initialObjectInintializer = useCallback(() =>
            itemEditing ? itemEditing : emptyObject
        , [])
    const {onChange, tempObject, setTempObject, onEditorChange} = useForm(initialObjectInintializer);
    console.log(tempObject)


    const notify = (message, type) => {
        toast(<div>
            <Row className={"g-0"}>
                <Col xs={12} className={"mb-3"}>
                    {message}
                </Col>
            </Row>
        </div>, {
            position: "top-right",
            autoClose: 5000,
            type: type,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
        });
    }

    async function handleCreate(event) {
        event.preventDefault();
        const response = await createAmodel({
            ...tempObject,
            geboorteDatum: (tempObject.geboorteDatum ? tempObject.geboorteDatum + 'T00:00:00' : new Date().toISOString()),
            opstellingDatum: (tempObject.opstellingDatum ? tempObject.opstellingDatum + 'T00:00:00' : new Date().toISOString())
        });
        if (response) {
            notify('Model A is verzonden.', 'success');
            const blob = await pdf(ModelAPdf({modelATempObject: tempObject})).toBlob();
            const pdfFile = new File([blob], `modelA-${new Date().toISOString().substring(0, 10)}${new Date().getMinutes()}${new Date().getMilliseconds()}.pdf`);
            const uploadFileResult = await uploadFile({file: pdfFile});
            if (uploadFileResult) {
                const newEmail = {
                    title: "VBFlw, Nieuw Model A formulier ingevuld",
                    emailto: tempObject.email,
                    emailfrom: "administratie@vbflw.be",
                    description: `
                    <p>Automatisch bericht van de VBFlw website:</p>
                    <p>Er is een Model A formulier ingevuld.</p>
                    <a href="${minioBaseUrl + uploadFileResult.url}">Click hier voor de pdf te downloaden</a>
                    `,
                    attachment: uploadFileResult.id
                };
                const emailResult = await createFormEmail(newEmail);
                if (emailResult) window.location.reload();
            }
        }
        if (!response) notify('Fout bij het verzenden. Probeer het later nog eens.', 'error');
    }

    async function handleEdit(e) {
        const result = await editAmodel(tempObject);
        if (result) {
            onItemEditingChanged(undefined);
            onOpenChanged(false);
        }
    }
    const formComplete =
        tempObject.sectorNummer &&
        (tempObject.sector !== 'Selecteer sector') &&
        tempObject.stamNrClub &&
        (tempObject.club !== 'Selecteer club') &&
        tempObject.geboorteDatum &&
        tempObject.sex !== 'Selecteer geslacht' &&
        tempObject.nationaliteit !== 'Selecteer nationaliteit' &&
        tempObject.land !== 'Selecteer land' &&
        tempObject.naam &&
        tempObject.voornaam &&
        tempObject.rijksRegisterNummer &&
        tempObject.straat &&
        tempObject.nr &&

        tempObject.postcode &&
        tempObject.gemeente &&
        tempObject.optie !== 'Selecteer reden';
    return <Form>

        <Section title={'A Algemeen'}>
            <Col xs={6}>
                <FormControlCustom title={'Sector-nr*'} disabled={true} value={tempObject.sectorNummer}
                                   filled={tempObject.sectorNummer}
                                   onChange={e => onChange(e, 'sectorNummer')}/>
            </Col>
            <Col xs={6}>

                <FormSelectCustom title={'Sector*'} value={tempObject.sector}
                                  filled={tempObject.sector !== 'Selecteer sector'}
                                  onChange={e => {
                                      const sector = sectors?.find(s => s.sectorNaam === e.target.value);
                                      setTempObject({
                                          ...tempObject,
                                          sector: e.target.value,
                                          sectorNummer: sector?.sectorNummer ? sector?.sectorNummer : " "
                                      });
                                  }}
                                  optionArray={[<option value={'Selecteer sector'}>Selecteer
                                      sector</option>, sectorsSorted?.map(s => <option key={s.id}
                                                                                       value={s.sectorNaam}
                                                                                       id={s.sectorNaam}>{s.sectorNaam}</option>)]}/>
            </Col>
            <Col xs={6}>

                <FormControlCustom title={'Stam nr-club*'} disabled={true} value={tempObject.stamNrClub}
                                   filled={tempObject.stamNrClub}
                                   onChange={e => onChange(e, 'stamNrClub')}/>
            </Col>
            <Col xs={6}>

                <FormSelectCustom title={'Club*'} value={tempObject.club} filled={tempObject.club !== 'Selecteer club'}
                                  onChange={e => {
                                      const club = clubs?.find(s => s.club === e.target.value);
                                      setTempObject({
                                          ...tempObject,
                                          club: e.target.value,
                                          stamNrClub: club?.stamNummer ? club?.stamNummer : " "
                                      });

                                  }}
                                  optionArray={[<option value={'Selecteer club'}>Selecteer
                                      club</option>, clubSorted?.map(s => <option key={s.id}
                                                                                  value={s.club}
                                                                                  id={s.club}>{s.club}</option>)]}/>
            </Col>
            <Col xs={4}>

                <FormControlCustom title={'Geboortedatum*'}
                                   value={tempObject.geboorteDatum?.length > 10 ? tempObject.geboorteDatum.substring(0, 10) : tempObject.geboorteDatum}
                                   filled={tempObject.geboorteDatum} type={'date'}
                                   onChange={e => {
                                       onChange(e, 'geboorteDatum');
                                       setTempObject({
                                           ...tempObject,
                                           geboorteDatum: e.target.value,
                                           categorie: checkCategoryFromDate(e.target.value, categories)
                                       })
                                   }}/>
            </Col>
            <Col xs={4}>
                <FormControlCustom title={'Categorie'} value={tempObject.categorie}
                                   onChange={e => onChange(e, 'categorie')}/>
            </Col>
            <Col xs={4}>
                <FormSelectCustom title={'Geslacht*'} value={tempObject.sex}
                                  filled={tempObject.sex !== 'Selecteer geslacht'}
                                  onChange={e => onChange(e, 'sex')}
                                  optionArray={[<option>Selecteer geslacht</option>, sexes?.map(s => <option key={s.id}
                                                                                                             value={s.title}
                                                                                                             id={s.title}>{s.title}</option>)]}/>
            </Col>

            <Col xs={6}>
                <FormControlCustom title={'Lidnr'} value={tempObject.lidnummer} type={'number'}
                                   onChange={e => onChange(e, 'lidnummer')}/>
            </Col>
            <Col xs={6}>


                <FormSelectCustom title={'Nationaliteit*'} value={tempObject.nationaliteit}
                                  filled={tempObject.nationaliteit !== 'Selecteer nationaliteit'}
                                  onChange={e => {
                                      setTempObject({
                                          ...tempObject,
                                          nationaliteit: e.target.value,
                                      });
                                  }}
                                  optionArray={[<option value={'Selecteer nationaliteit'}>Selecteer
                                      nationaliteit</option>, countrycodes?.map(s => <option key={s.id}
                                                                                       value={s.label}
                                                                                       id={s.id}>{s.label}</option>)]}/>
            </Col>
            <Col xs={12} className={'visually-hidden'}>
                <FormLabel>Datum opstelling*</FormLabel>
                <FormControl disabled={true}
                             value={tempObject.opstellingDatum?.length > 10 ? tempObject.opstellingDatum.substring(0, 10) : tempObject.opstellingDatum}
                             type={'date'}
                             onChange={e => onChange(e, 'opstellingDatum')}/>
            </Col>
            <Col xs={4}>

                <FormControlCustom title={'Naam*'} value={tempObject.naam} filled={tempObject.naam}
                                   onChange={e => onChange(e, 'naam')}/>
            </Col>
            <Col xs={4}>

                <FormControlCustom title={'Voornaam*'} value={tempObject.voornaam} filled={tempObject.voornaam}
                                   onChange={e => onChange(e, 'voornaam')}/>
            </Col>
            <Col xs={4}>

                <FormControlCustom title={'Rijksregnr*'} value={tempObject.rijksRegisterNummer}
                                   filled={tempObject.rijksRegisterNummer}
                                   onChange={e => onChange(e, 'rijksRegisterNummer')}/>
            </Col>

        </Section>
        <hr className={'my-2'}/>
        <Section title={'B Woonplaats'}>
            <Col xs={4}>

                <FormControlCustom title={'Straat*'} value={tempObject.straat} filled={tempObject.straat}
                                   onChange={e => onChange(e, 'straat')}/>
            </Col>
            <Col xs={4}>

                <FormControlCustom title={'Huisnr*'} value={tempObject.nr} filled={tempObject.nr}
                                   onChange={e => onChange(e, 'nr')}/>
            </Col>
            <Col xs={4} className={'p-1'}>
                <FormLabel>Bus</FormLabel>
                <FormControl value={tempObject.bus} onChange={e => onChange(e, 'bus')}/>
            </Col>
            <Col xs={4}>


                <FormSelectCustom title={'Land*'} value={tempObject.land}
                                  filled={tempObject.land !== 'Selecteer land'}
                                  onChange={e => {
                                      setTempObject({
                                          ...tempObject,
                                          land: e.target.value,
                                      });
                                  }}
                                  optionArray={[<option value={'Selecteer land'}>Selecteer
                                      land</option>, countrycodes?.map(s => <option key={s.id}
                                                                                             value={s.label}
                                                                                             id={s.id}>{s.label}</option>)]}/>
            </Col>
            <Col xs={4}>

                <FormControlCustom title={'postcode*'} value={tempObject.postcode} filled={tempObject.postcode}
                                   onChange={e => onChange(e, 'postcode')}/>
            </Col>
            <Col xs={4}>

                <FormControlCustom title={'Gemeente*'} value={tempObject.gemeente} filled={tempObject.gemeente}
                                   onChange={e => onChange(e, 'gemeente')}/>
            </Col>
            <Col xs={6}>

                <FormControlCustom title={'Tel/Gsm'} value={tempObject.telefoon}
                                   onChange={e => onChange(e, 'telefoon')}/>
            </Col>
            <Col xs={6}>

                <FormControlCustom title={'Email'} type={'email'} value={tempObject.email}
                                   onChange={e => onChange(e, 'email')}/>
            </Col>
        </Section>
        <hr className={'my-2'}/>
        <Section>
            <Col xs={12}>

                <FormSelectCustom title={'Reden van indiening*'} value={tempObject.optie}
                                  filled={tempObject.optie !== 'Selecteer reden'}
                                  onChange={e => onChange(e, 'optie')}
                                  optionArray={[<option
                                      value={"Selecteer reden"}>Selecteer reden</option>,
                                      <option value={"Nieuw lid"}>Nieuw lid</option>,
                                      <option value={"Mutatie transfert stam ex-club"}>Mutatie transfert stam
                                          ex-club</option>,
                                      <option value={"Heraansluiting"}>Heraansluiting</option>,
                                      <option value={"Wijziging algemene gegevens"}>Wijziging algemene
                                          gegevens</option>,
                                      <option value={"Wijziging adres woonplaats"}>Wijziging adres woonplaats</option>,
                                      <option value={"Wijziging adres briefwisseling"}>Wijziging adres
                                          briefwisseling</option>,
                                      <option value={"Vervangen lidkaart"}>Vervangen lidkaart</option>,
                                      <option value={"Ontslag"}>Ontslag</option>]}/>
                {tempObject?.optie === 'Mutatie transfert stam ex-club' ?
                    <strong className={'p-1'}>Vermeld uw nummer en naam van de club bij de opmerking hier onder
                        aub.</strong> : ''}
            </Col>
            <Row className={'g-0 p-1'}>
                <FormLabel>Opmerking</FormLabel>
                <Col>
                    <CustomEditor height={100} initText={tempObject.opmerking} fieldName={'opmerking'}
                                  disableToolbar={true}
                                  onEditorChange={onEditorChange}/>

                </Col>
            </Row>
            {itemEditing ? <Col xs={6} className={'p-1'}>
                <Section>
                    <Col xs={12}>
                        <FormLabel htmlFor={'vzwjn'}>Verwerkt? </FormLabel>
                    </Col>
                    <Col xs={'auto'}>
                        <LabelWithInput title={'ja'}> <FormCheck id={'verwerktja'} defaultChecked={tempObject.verwerkt}
                                                                 name={'verwerkt'} value={"true"} type={'radio'}
                                                                 onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>

                    </Col>
                    <Col xs={'auto me-2'}>
                        <LabelWithInput title={'nee'}> <FormCheck id={'verwerktnee'}
                                                                  defaultChecked={!tempObject.verwerkt}
                                                                  name={'verwerkt'}
                                                                  value={"false"} type={'radio'}
                                                                  onChange={e => onChange(e, 'verwerkt')}/></LabelWithInput>
                    </Col>
                </Section>
            </Col> : ''}
        </Section>
        <Section>
            <Col xs={12} className={'text-end p-1'}>

                <Button disabled={!formComplete} type={'button'}
                        onClick={e => itemEditing ? handleEdit(e) : handleCreate(e)}>{!formComplete ? 'Nog niet alle verplichte * velden zijn ingevuld!' : 'Submit'}</Button>
            </Col>
        </Section>

    </Form>

}